import { CardDescription, MarketingContainer, CardTitle, GridWrapper } from "./style";
import { Box } from "@mui/material";
import { data } from "./constants";

export default function CleaningServices() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: 10, rowGap: 5 }}>
      <label style={{ color: "#4a7094", fontWeight: "bold", fontSize: 35, textAlign: "center" }}>
        Cleaning Services
      </label>

      <GridWrapper>
        {data.map((item, index) => (
          <MarketingContainer key={index}>
            <Box style={{ display: "flex", justifyContent: "center", marginBottom: 10 }}>
              <img src={item.image} alt={item.title} style={{ width: 200, height: 200, objectFit: "cover", borderRadius: 0 }} />
            </Box>
            <CardTitle>{item.title}</CardTitle>
            <CardDescription>{item.description}</CardDescription>
          </MarketingContainer>
        ))}
      </GridWrapper>
    </Box>
  );
}
